module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-game"
  }, _vm._l((_vm.games), function(game) {
    return _c('content-item', {
      attrs: {
        "title": game.app_name
      }
    }, [_c('div', {
      staticClass: "game-item"
    }, [_c('div', {
      staticClass: "app-icon",
      style: ('background: url(' + game.game_center_pic_url + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "app-desc"
    }, [_c('div', {
      staticClass: "app-name"
    }, [_vm._v(_vm._s(game.app_name))]), _vm._v(" "), _c('div', {
      staticClass: "app-content"
    }, [_c('div', {
      staticClass: "left-info"
    }, [_c('p', {
      staticClass: "app-detail"
    }, [_vm._v(_vm._s(game.tips))]), _vm._v(" "), _c('a', {
      staticClass: "app-site",
      attrs: {
        "target": "_blank",
        "href": game.detail_href
      }
    }, [_vm._v("more"), _c('i', {
      staticClass: "fa fa-angle-double-right"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "right-links"
    }, [_c('div', {
      staticClass: "app-links"
    }, [(game.app_store_href != '') ? _c('a', {
      staticClass: "btn-apple",
      attrs: {
        "href": game.app_store_href
      }
    }) : _vm._e(), _vm._v(" "), (game.google_play_href != '' && game.app_name !== '幻想英雄') ? _c('a', {
      staticClass: "btn-google",
      attrs: {
        "href": game.google_play_href
      }
    }) : _vm._e(), _vm._v(" "), (game.google_play_href != '' && game.app_name === '幻想英雄') ? _c('a', {
      staticClass: "btn-taptap",
      attrs: {
        "href": game.google_play_href
      }
    }) : _vm._e(), _vm._v(" "), (game.apk_href != '') ? _c('a', {
      staticClass: "btn-apk",
      attrs: {
        "href": game.apk_href
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.$t('download')) + "\n                            ")]) : _vm._e()])])])])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d8a14d7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
// module id = 366
// module chunks = 5